import './src/styles/global.css'

require('@fontsource/pattaya')
require('@fontsource/open-sans/latin.css')
